// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "./public-path";
import "./tailwindcss.css";
import "./compositionApi";
import "./api/init-op-utils-self-axios";
import "./util/useOpUI";
import Vue from "vue";
import store from "@/store";
import initRouter from "@/router";
import App from "@/App";
import { api, apiGet } from "@/api/index";
import "@/util/data_collection.js";
import "@/util/init.js";
import { i18n, setup } from "@/locales";
import { getQueryString, getQueryParam } from "@/util/extends/cookieExpand";
import "font-awesome-webpack";
//引入UI组件
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";

import "@/assets/theme/index.css";
//Vue.use(ElementUI)
//引入sass生产的css
import "@/assets/css/style.css";
//引入全局过滤器
import "@/util/filter";
import { actions, routeGuardCrumbsListFactory, getDict } from "@oppein/op-utils";
import { updateBrand, updateCategory } from "@/util/dict";
import { addKeepAliveInclude } from "./util/keepAlive";
import {
  initRelatedApproval,
  initDeliveryMethod,
  initReceiveAddress,
  initConfigurationGoods,
  initDeliveryDetails,
  initOrderCycle,
  initHouseTypeEditDialog,
  initBatchTransmit,
} from "@oppein/op-web-components";
import loadingService from "@/util/loadingService";
initDeliveryMethod("op-web-delivery-method");
initRelatedApproval("op-web-related-approval");
initReceiveAddress("op-web-receive-address");
initConfigurationGoods("op-web-configuration-goods");
initDeliveryDetails("op-web-delivery-details");
initOrderCycle("op-web-order-cycle");
initHouseTypeEditDialog("op-web-house-type-edit-dialog");
initBatchTransmit('op-web-batch-transmit')
console.log(`应用构建时间: ${process.env.VUE_APP_BUILD_TIME || "未知"}`);

Vue.prototype.setSessionItem = (key, newVal) => {
  // 创建 StorageEvent 事件
  let newStorageEvent = document.createEvent("StorageEvent");
  const storage = {
    setItem: function (k, val) {
      sessionStorage.setItem(k, val);
      // 初始化 StorageEvent 事件
      newStorageEvent.initStorageEvent(
        "setItem", // 事件别名
        false,
        false,
        k,
        null,
        val,
        null,
        null,
      );

      // 派发事件
      window.dispatchEvent(newStorageEvent);
    },
  };
  return storage.setItem(key, newVal);
};
Vue.config.productionTip = false;

let instance = null;
let router = null;
async function render(props = {}) {
  const { container } = props;
  // 初始化品牌和品类字典
  // const [brandData, categoryData] = await Promise.all([
  //   getDict("ROOT_brand"),
  //   getDict("ROOT_category"),
  // ]);
  // updateBrand(brandData);
  // updateCategory(categoryData);
  const router = initRouter();
  const routeGuard = routeGuardCrumbsListFactory({
    childrenPath: "microapp-caxaOneClickOrder",
    blacklist: [],
  });
  router.beforeEach(routeGuard);
  router.beforeEach(addKeepAliveInclude);
  // new collectionData().init()
  router.beforeEach(async (to, from, next) => {
    if (to && to.path === "/confirmCustomerInfo") {
      loadingService.show("数据加载中，请您耐心等候");
    }
    if (getQueryString("version")) {
      sessionStorage.setItem("caxaVersion", getQueryString("version"));
    }
    if (getQueryString("softWareDesignType")) {
      sessionStorage.setItem(
        "softWareDesignType",
        getQueryString("softWareDesignType"),
      );
    }
    if (getQueryString("pageId")) {
      store.commit("commonModule/SET_MAJOR_ID", getQueryString("pageId"));
    }
    if (getQueryString("fileId")) {
      sessionStorage.setItem("kjlFileId", getQueryString("fileId"));
    }
    if (getQueryString("spliteOrder2")) {
      sessionStorage.setItem("spliteOrder2", getQueryString("spliteOrder2"));
    }
    if (getQueryString("takeApartOrder2")) {
      sessionStorage.setItem("takeApartOrder2", getQueryString("takeApartOrder2"));
    }
    if (getQueryString("fileName") && getQueryParam("fileName")) {
      sessionStorage.setItem("kjlFileName", getQueryParam("fileName"));
    }
    if (getQueryString("category")) {
      sessionStorage.setItem("urlCategory", getQueryString("category"));
    }
    if (getQueryString("businessTypeChange") === "oppeinToproject") {
      sessionStorage.removeItem("dictionarys");
      sessionStorage.removeItem("orderForm");
      sessionStorage.setItem("businessTypeChange", "oppeinToproject");
      sessionStorage.setItem("businessType", "project");
      localStorage.setItem(
        "businessType",
        sessionStorage.getItem("businessType"),
      );
    }
    if (getQueryString("businessTypeChange") === "oppeinToprojectWm") {
      sessionStorage.removeItem("dictionarys");
      sessionStorage.removeItem("orderForm");
      sessionStorage.setItem("businessTypeChange", "oppeinToprojectWm");
      sessionStorage.setItem("businessType", "project");
      localStorage.setItem(
        "businessType",
        sessionStorage.getItem("businessType"),
      );
    }
    let lang = getQueryString("ui")
      ? getQueryString("ui").toLowerCase()
      : localStorage.getItem("orderLocaleLanguage")
        ? localStorage.getItem("orderLocaleLanguage")
        : "cn";
    if (lang === "en") {
      Vue.use(ElementUI, { locale });
    } else {
      Vue.use(ElementUI);
    }
    setup(lang);
     // 初始化品牌和品类字典
    const [brandData, categoryData] = await Promise.all([
      getDict("ROOT_brand"),
      getDict("ROOT_category"),
    ]);
    updateBrand(brandData);
    updateCategory(categoryData);
    let getMenus = async () => {
      let menus = store.getters.menuTree;
      if (!getQueryString("pageId")) {
        await store.dispatch("postGenerateMajorIdAction");
      }
      await store.dispatch("postGenerateRequestIdAction");
      if (!(Array.isArray(menus) && menus.length > 0)) {
        try {
          await store.dispatch("GET_MENU");
          next();
        } catch (err) {
          next();
        }
      } else {
        next();
      }
    };
    if (to && to.meta && to.meta.white) {
      next();
    } else {
      let user = store.getters.user;
      if (user && user.id) {
        getMenus();
      } else {
        store
          .dispatch("getUserInfo")
          .then((res) => {
            // 验证用户是否登录并获取用户登录信息
            if (res.status) {
              if (res.data.id && process.env.COLLECTION_PATH) {
                if (window.opCollect) {
                  window.opCollect.setMtdsId(res.data.id); // B端用户id
                  window.opCollect.init({
                    appid: "pcnpft7th2hxwhhq3z",
                    appCode: "CAXA", // appCode
                    subAppCode: "CAXAPC001", // subAppCode
                    eventType: ["click"], // pc用click，移动端用touchend
                  });
                }
              }
              getMenus();
            } else {
              next({ path: "/resources/loseToken" });
            }
          })
          .catch((err) => {
            next({ path: "/resources/loseToken" });
            console.log(err);
          });
      }
    }
  });
  router.afterEach((to) => {
    //进度条 end
    loadingService.close();
  });

  if (
    window.__POWERED_BY_QIANKUN__ &&
    window.__CACHE_DATA_BY_QIAN_KUN_FOR_CAXA_ONE_CLICK_ORDER__
  ) {
    const cachedInstance =
      window.__CACHE_DATA_BY_QIAN_KUN_FOR_CAXA_ONE_CLICK_ORDER__;

    // 从最初的Vue实例上获得_vnode
    const cachedNode = cachedInstance._vnode;

    // 让当前路由在最初的Vue实例上可用
    // router.apps.push(...cachedInstance.$router.apps)
    router.apps.push(...cachedInstance.catchRoute.apps);

    instance = new Vue({
      router,
      store,
      i18n,
      render: (h) => cachedNode,
    });

    router.onReady(() => {
      const { path, name, query, params } = router.currentRoute;
      const { path: oldPath } = cachedInstance.$router.currentRoute;
      // 当前路由和上一次卸载时不一致，则切换至新路由
      if (path !== oldPath) {
        cachedInstance.$router.push({
          name,
          query,
          params,
        });
      }
      if (
        !router.currentRoute.meta ||
        !router.currentRoute.meta.componentName
      ) {
        router.replace({
          name,
          query: { ...query, timeStamp: new Date().getTime() },
          params,
        });
      }
    });

    instance.$mount(container ? container.querySelector("#app") : "#app");
  } else {
    /* eslint-disable no-new */
    instance = new Vue({
      store,
      router,
      i18n,
      //    $,
      render: (h) => <App />,
    }).$mount(container ? container.querySelector("#app") : "#app");
  }
}
// 独立运行时
if (!window.__POWERED_BY_QIANKUN__) {
  render();
}
export async function bootstrap() {
  console.log("[vue] vue app bootstraped");
}
export async function mount(props) {
  actions.setActions(props);
  render(props);
}
// 增加 update 钩子以便主应用手动更新微应用
export async function update(props) {
  render(props);
}
export async function unmount() {
  const cachedInstance = instance.cachedInstance || instance;
  window.__CACHE_DATA_BY_QIAN_KUN_FOR_CAXA_ONE_CLICK_ORDER__ = cachedInstance;
  const cachedNode = cachedInstance._vnode;
  // 让keep-alive可用
  if (!cachedNode.data.keepAlive) cachedNode.data.keepAlive = true;
  cachedInstance.catchRoute = {
    apps: [...instance.$router.apps],
  };
  instance.$router.apps = [];
  instance.$destroy();
  // instance.$el.innerHTML = ''
  instance = null;
  router = null;
}



// WEBPACK FOOTER //
// ./src/main.js